import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import SectionHeading from "../components/SectionHeading.js";
import { TERMS_SECTIONS } from "../content/landingContent.js";

const TermsPage = observer(() => {
  const { t } = useTranslation();
  return (
    <article className="landing-page landing-terms">
      <SectionHeading eyebrow={t("landing.terms.eyebrow")} title={t("landing.terms.title")}
        body={t("landing.terms.lead")} />
      <p className="landing-terms-date">{t("landing.terms.updated")}</p>
      <div className="landing-legal-copy">
        {TERMS_SECTIONS.map((section, index) => (
          <section key={section.titleKey}>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <div>
              <h2>{t(section.titleKey)}</h2>
              {section.bodyKeys.map((key) => <p key={key}>{t(key)}</p>)}
            </div>
          </section>
        ))}
      </div>
    </article>
  );
});

export default TermsPage;
